import { render, staticRenderFns } from "./SetUpDrugbook.vue?vue&type=template&id=08c89d0c&"
import script from "./SetUpDrugbook.vue?vue&type=script&lang=js&"
export * from "./SetUpDrugbook.vue?vue&type=script&lang=js&"
import style0 from "./SetUpDrugbook.vue?vue&type=style&index=0&id=08c89d0c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports